import React from 'react';

import {
    Grid,
    Button,
    Divider,
    Collapse
} from '@mui/material';
import {
    CheckBox,
    CheckBoxOutlineBlank,
    ExpandMore,
    ExpandLess,
    Forest
} from '@mui/icons-material';

import { BoolField } from '@commonComponents/Form';
import { SectionDivider } from '@commonComponents';
import { TenantProfileType, METADATA_TYPES } from '@types';
import { hasStandardProperty } from '@utils/metadata';

interface SustainabilityProps {
    onAllNone: ({ key, array }: { key: string; array: string[] }) => void;
    onClick: ({ key, value }: { key: string; value: string }) => void;
    settables: string[];
    sustainability: TenantProfileType['sustainability'];
}

const Sustainability: React.FC<SustainabilityProps> = (props) => {
    const {
        onAllNone,
        onClick,
        settables = [],
        sustainability = []
    } = props;

    const [collapsed, setCollapsed] = React.useState<boolean>(false);
    const [selected, setSelected] = React.useState<'all' | 'some' | 'none'>('some');
    const key = METADATA_TYPES.SUSTAINABILITY;

    React.useEffect(() => {
        if (settables.every((sus) => sustainability.includes(sus))) {
            setSelected('all');
        } else if (sustainability.length === 0) {
            setSelected('none');
        } else {
            setSelected('some');
        }
    }, [sustainability, settables]);

    const selectAll = () => {
        const newSus = Array.from(new Set([...sustainability, ...settables]));
        onAllNone({ key, array: newSus });
    };

    const selectNone = () => {
        const newSus = sustainability.filter((sus: string) => !settables.includes(sus));
        onAllNone({ key, array: newSus });
    };

    return (
        <Grid item xs={12} lg={6}>
            <SectionDivider
                label={(
                    <>
                        {`Hållbarhet  (${sustainability?.length || 0}) `}
                        {collapsed ? <ExpandMore /> : <ExpandLess />}
                    </>
                )}
                icon={<Forest fontSize="small" />}
                marginTop={0}
                marginBottom={2}
                onClick={() => setCollapsed(!collapsed)}
            />
            <Collapse in={!collapsed}>
                <Grid container spacing={1} sx={{ mb: 1 }}>
                    <Grid item>
                        <Button
                            size="small"
                            variant="text"
                            onClick={() => selectAll()}
                            startIcon={selected === 'all' ? <CheckBox /> : <CheckBoxOutlineBlank />}
                            sx={{ fontWeight: 300 }}
                        >
                            Alla
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            size="small"
                            variant="text"
                            onClick={() => selectNone()}
                            startIcon={selected === 'none' ? <CheckBox /> : <CheckBoxOutlineBlank />}
                            sx={{ fontWeight: 300 }}
                        >
                            Inga
                        </Button>
                    </Grid>
                </Grid>
                <Divider sx={{ mb: 2, width: '160px' }} />
                <Grid container spacing={1}>
                    {settables.map((sus) => (
                        <Grid item xs={12} sm={6} md={4} key={sus}>
                            <BoolField
                                name={sus}
                                label={sus}
                                value={hasStandardProperty({
                                    array: sustainability,
                                    value: sus
                                })}
                                onChange={() => onClick({ key, value: sus })}
                                sx={{ py: 0.25 }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Collapse>
        </Grid>
    );
};

export default Sustainability;
